import React from 'react';
import { Inbox, Layers } from 'lucide-react';
import { MapaHorarios } from '../compartidos/MapaHorarios';
import { IngresosEgresos } from '../compartidos/IngresosEgresos';
import { Contrapartes } from '../compartidos/Contrapartes';
import { PanelAnalisis } from '../compartidos/PanelAnalisis';
import { formatoMonto, useAnalisis } from '../compartidos/useAnalisis';

const PorTipoOperacion = ({ casoId, episodioId }) => {
  const { data, loading, error } = useAnalisis({ casoId, episodioId });
  const filas = data?.por_tipo || [];
  const max = Math.max(1, ...filas.map((f) => f.cantidad));
  return (
    <PanelAnalisis titulo="Por tipo de operación" icono={Layers} testid="por-tipo-operacion" loading={loading} error={error}
      vacio={data && !filas.length ? 'Sin movimientos' : null}>
      <div className="space-y-2">
        {filas.map((f) => (
          <div key={f.tipo} className="flex items-center gap-3 text-xs" data-testid={`por-tipo-${f.tipo}`}>
            <span className="w-32 truncate text-right text-slate-600" title={f.tipo}>{f.tipo}</span>
            <div className="h-6 flex-1 overflow-hidden rounded-md bg-slate-100">
              <div className="flex h-full items-center rounded-md bg-indigo-600 px-2 text-[11px] font-bold text-white transition-[width] duration-500"
                style={{ width: `${Math.max(6, (f.cantidad / max) * 100)}%` }}>{f.cantidad}</div>
            </div>
            <span className="w-28 text-right font-mono text-slate-500">{formatoMonto(f.monto)}</span>
          </div>
        ))}
      </div>
    </PanelAnalisis>
  );
};

// F3 / G2: análisis del caso completo o del episodio, con los componentes compartidos.
export const AnalisisCaso = ({ casoId, episodioId }) => {
  const { data } = useAnalisis({ casoId, episodioId });
  if (episodioId && data && !data.total) {
    return (
      <div className="flex flex-col items-center py-10 text-slate-400" data-testid="analisis-caso-vacio">
        <Inbox size={32} className="mb-2" />
        <p className="text-sm">Este episodio no tiene movimientos cargados</p>
      </div>
    );
  }
  return (
    <div className="space-y-5" data-testid="analisis-caso">
      <MapaHorarios casoId={casoId} episodioId={episodioId} />
      <div className="grid gap-5 xl:grid-cols-2">
        <IngresosEgresos casoId={casoId} episodioId={episodioId} />
        <PorTipoOperacion casoId={casoId} episodioId={episodioId} />
      </div>
      <Contrapartes casoId={casoId} episodioId={episodioId} />
    </div>
  );
};

export default AnalisisCaso;
